module.exports = __webpack_public_path__ + "static/media/customer-belirium.c4475e5b.png";